import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../../data.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';

@Component({
	selector: 'app-logout',
	templateUrl: './logout.component.html',
	styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

	constructor(public globalSearchService: GlobalSearchService, public router: Router, public dataService: DataService) { }

	ngOnInit() {

		// Preserve company config keys before clearing — the AuthInterceptor reads
		// v8ConfigOverride on every HTTP request to build the Authorization header,
		// and config-switcher uses v8ActiveSetupKey to know which tenant is active.
		// Neither is user-session data; losing them breaks all API calls post-login.
		// The POS data that triggered localStorage.clear() (Trello lDHvApFH) lives
		// in other keys and is handled by the subject reset below.
		const savedConfigOverride = (() => { try { return localStorage.getItem('v8ConfigOverride'); } catch { return null; } })();
		const savedActiveSetupKey = (() => { try { return localStorage.getItem('v8ActiveSetupKey'); } catch { return null; } })();
		// v8version must survive too: AuthGuard deletes v8ConfigOverride and reloads
		// whenever v8version is null/changed. Clearing it here made the guard treat
		// the next login as a fresh install and silently drop the override we just
		// preserved above — reverting the user to their default config.
		const savedVersion = (() => { try { return localStorage.getItem('v8version'); } catch { return null; } })();

		// printSettings binds this physical workstation to its print-connect
		// devices (keyed by user). It's machine config, not user-session data —
		// wiping it on logout forces every user to re-pair their printer.
		const savedPrintSettings = (() => { try { return localStorage.getItem('printSettings'); } catch { return null; } })();

		try { localStorage.clear(); } catch {}
		try { sessionStorage.clear(); } catch {}

		if (savedConfigOverride) { try { localStorage.setItem('v8ConfigOverride', savedConfigOverride); } catch {} }
		if (savedActiveSetupKey) { try { localStorage.setItem('v8ActiveSetupKey', savedActiveSetupKey); } catch {} }
		if (savedVersion) { try { localStorage.setItem('v8version', savedVersion); } catch {} }
		if (savedPrintSettings) { try { localStorage.setItem('printSettings', savedPrintSettings); } catch {} }

		// Reset singleton service state that survives navigation. Just
		// removing localStorage keys isn't enough because BehaviorSubjects
		// in GlobalSearchService hold the customer / payment context in
		// memory until the page is actually reloaded.
		const g = this.globalSearchService;
		const subjectsToClear = [
			'customerData', 'lastCustomer', 'lastCustomerTrans', 'lastItem',
			'orderData', 'orderResults', 'currentOrderList', 'openOrderData',
			'pickingOrderData', 'package', 'searchResults', 'searchTerm',
			'dispatchNote', 'invoiceNote', 'poEntered', 'empCode',
			'selectedlocation', 'discountsAllowed', 'userData', 'user',
			'locationData', 'datasets', 'vendorData', 'allItems',
			'messages', 'mesagesallowed',
		];
		for (const key of subjectsToClear) {
			try { g[key]?.next?.(null); } catch {}
		}

		this.router.navigate(['auth/login']);
		g.currentsetuser = false;

	}

}
